import isValidVar from './isValidVar';

/**
  * @memberof checkVarType
  * @name isString
  * Check if a variable is a string
  * @param {any} x variable to be checked
  * @returns {boolean} is the variable a string?
*/
const isString = (x) => isValidVar(x) && typeof x === 'string';

export default isString;
